import { closeOtherDropdowns } from 'common-front/src/designSystem/components/dropdown/dropdown';
import { DropdownEllipsis } from 'common-front/src/designSystem/components/dropdown/dropdownEllipsis';
import { ItemIcon } from 'common-front/src/designSystem/components/dropdown/item';
import { RolesQuery } from 'common/src/generated/types';
import { useHistory, useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { isEditable } from '../../isEditable';
import { DeleteRoleModal } from './deleteRoleModal';

export const Dropdown = ({
    onDelete,
    role
}: {
    onDelete: React.ComponentProps<typeof DeleteRoleModal>['onDelete'];
    role: RolesQuery['organization']['roles'][number];
}) => {
    const { organizationId } = useParams();
    const translate = useTranslate();
    const history = useHistory();
    const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);

    return (
        <>
            <DropdownEllipsis>
                {isEditable(role) && (
                    <>
                        <ItemIcon
                            icon="pen"
                            onClick={() => {
                                history.push(
                                    HeaventPaths.EDIT_ORGANIZATION_PARAMETERS_ROLE(
                                        organizationId,
                                        role.id
                                    )
                                );
                            }}
                        >
                            {translate('_diter_62574')}
                        </ItemIcon>
                        <ItemIcon
                            icon="clone"
                            onClick={() => {
                                history.push(
                                    HeaventPaths.DUPLICATE_ORGANIZATION_PARAMETERS_ROLE(
                                        organizationId,
                                        role.id
                                    )
                                );
                            }}
                        >
                            {translate('dupliquer_28256')}
                        </ItemIcon>
                        <ItemIcon
                            color="red"
                            icon="trash-can"
                            onClick={(e) => {
                                closeOtherDropdowns(e.target);
                                setIsDeleteOpen(true);
                            }}
                        >
                            {translate('supprimer_43083')}
                        </ItemIcon>
                    </>
                )}
                {!isEditable(role) && (
                    <>
                        <ItemIcon
                            icon="eye"
                            onClick={() => {
                                history.push(
                                    HeaventPaths.EDIT_ORGANIZATION_PARAMETERS_ROLE(
                                        organizationId,
                                        role.id
                                    )
                                );
                            }}
                        >
                            {translate('voir_36533')}
                        </ItemIcon>
                        <ItemIcon
                            icon="clone"
                            onClick={() => {
                                history.push(
                                    HeaventPaths.DUPLICATE_ORGANIZATION_PARAMETERS_ROLE(
                                        organizationId,
                                        role.id
                                    )
                                );
                            }}
                        >
                            {translate('dupliquer_28256')}
                        </ItemIcon>
                    </>
                )}
            </DropdownEllipsis>
            {isDeleteOpen && (
                <DeleteRoleModal
                    role={role}
                    onClose={() => {
                        setIsDeleteOpen(false);
                    }}
                    onDelete={onDelete}
                />
            )}
        </>
    );
};
